export const environment = {
  env: 'uat',
  production: false,
  oidc: {
    clientId: '0oaa2kwrrtLzJPJUq4h7',
    issuer: 'https://relayhealth.okta.com/oauth2/ausa2l06zjZ9jX0tU4h7',
    redirectUri: 'login/callback',
    scopes: ['openid'],
    pkce: false
  },
  authPrefix: 'PRD-UAT',
  authGroup: 'SmartHopUI-Users',
  appUrl: 'https://smarthop-config-uat.relayhealth.com',
  apiUrl: 'https://smarthop-config-api-uat.relayhealth.com'
};